import { LoadingBar } from "@cividao/components"
import { useLayout } from "../../../../context/LayoutContext"
import { useLogos } from "../../../../hooks/useLogos"

export const Loading = () => {
  const { themeMode } = useLayout()
  const { logo } = useLogos()

  return <LoadingBar mode={themeMode} isFullScreen icon={<img src={logo} />} />
}
